import React from 'react';

import { Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as DropDownArrow } from '../../assets/images/expand_more_24px.svg';
import { ReactComponent as DropDownArrowGreen } from '../../assets/images/expand_more_24px_green.svg';
import languageIcon from '../../assets/images/language_icon.svg';
import { t } from '../../providers';

const useStyles = makeStyles((theme) => ({
    language: {
        display: 'flex',
        flexFlow: 'row nowrap',
        marginRight: '22px',
    },
    languageSelect: {
        '&.MuiInputBase-root': {
            border: 'none',
            width: '128px',
            height: '32px',
        },
        '& .MuiSelect-icon': {
            paddingTop: '4px',
        },
        '& .MuiSelect-select.MuiSelect-select': {
            paddingRight: '0px',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
        '&.MuiInputBase-root.Mui-focused': {
            color: '#669934',
        },
        '& .MuiSelect-iconOpen': {},
    },
    langFlag: {
        width: '20px',
        height: '20px',
        verticalAlign: 'middle',
    },
    langOption: {
        fontSize: '0.75rem',
        color: '#223211',
        margin: '0px 6px 0px 10px',
        fontWeight: '600',
        letterSpacing: '0.5px',
        padding: 0,
        height: 'auto',
        '& .MuiButtonBase-root': {
            height: '12px',
            fontSize: '0.75rem',
            color: '#223211',
            margin: 10,
            fontWeight: '600',
            letterSpacing: '0.5px',
            padding: 10,
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
    },
    hideElement: {
        display: 'none',
    },
    dropdownStyle: {
        width: '125px',
        marginTop: '15px',
        marginLeft: '-2px',
        padding: '0px 0px',
        '& .MuiListItem-button': {
            padding: 0,
            margin: 0,
        },
        '& .MuiListItem-button:focus': {
            background: 'none',
        },
    },
}));

const LanguageSelect = ({ languages, updateLanguage, langSelectorIsOpen, lang, languageSelectClose, languageSelectOpen }) => {
    const classes = useStyles();
    const languageSelectIcon = langSelectorIsOpen ? DropDownArrowGreen : DropDownArrow;

    return (
        <Select
            SelectDisplayProps={{
                'aria-label': `${t('select.language')}`,
                role: 'combobox',
                'aria-controls': 'language-select',
                'aria-expanded': langSelectorIsOpen,
                'aria-labelledby': undefined,
            }}
            id="lng-select"
            className={classes.languageSelect}
            displayEmpty
            label={t('select.language')}
            onChange={updateLanguage}
            value={lang}
            onOpen={languageSelectOpen}
            onClose={languageSelectClose}
            IconComponent={languageSelectIcon}
            MenuProps={{
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                anchorPosition: {
                    top: 75,
                    left: 964,
                },
                classes: { paper: classes.dropdownStyle },
                'aria-haspopup': true,
                MenuListProps: { role: 'listbox', id: 'language-select' },
            }}>
            {languages.map(({ key, value, code }, idx) => (
                <MenuItem
                    style={!langSelectorIsOpen ? { display: 'none' } : {}}
                    aria-selected={lang === code ? 'true' : 'false'}
                    id={`${code}_lang`}
                    key={`${key}_${idx}`}
                    value={code}
                    lang={code}
                    className={lang === code ? classes.hideElement : ''}>
                    {lang === code && <img src={languageIcon} className={classes.langFlag} alt="" />}
                    <span className={classes.langOption}>
                        {lang === code ? (
                            value
                        ) : (
                            <Button id={`${code}_btn`} disableFocusRipple>
                                {value}
                            </Button>
                        )}
                    </span>
                </MenuItem>
            ))}
        </Select>
    );
};

export default LanguageSelect;
